import { assign } from 'lodash'
import { default as doFilter } from './filters'

export default function (professional) {
  const agenda = assign({}, professional)
  const searchedBy = []
  const filters = {}

  doFilter(searchedBy, filters, agenda)

  this.setValuesSearchedBy(searchedBy)
  this.setFilters(filters)

  this.loadAgendas()
    .then(() => {
    })

  return this.$router.push({name: 'patient.agendas.search.results'})
}



// WEBPACK FOOTER //
// ./src/app/patient/favorite-list/resources/methodDoLoad.js